import _slicedToArray from '../../../@babel/runtime/helpers/esm/slicedToArray.js';
import { registerElement } from './registerElement.js';
import { Cache } from './Cache.js';

/**
 * @typedef {import('./types').ScopedElementsMap} ScopedElementsMap
 */

/**
 * Allowed tag name chars
 *
 * @type {string}
 */
var chars = "-|\\.|[0-9]|[a-z]";

/**
 * Regular Expression to find a custom element tag
 *
 * @type {RegExp}
 */
var re = new RegExp("<\\/?([a-z](".concat(chars, ")*-(").concat(chars, ")*)"), 'g');

/**
 * The global cache of processed string arrays
 *
 * @type {Cache<TemplateStringsArray, TemplateStringsArray>}
 */
var globalCache = new Cache();

/**
 * Find custom element tags in the string
 *
 * @param {string} str
 * @returns {RegExpExecArray[]}
 */
var matchAll = function matchAll(str) {
  var matches = [];
  var result;
  // eslint-disable-next-line no-cond-assign
  while ((result = re.exec(str)) !== null) {
    matches.push(result);
  }
  return matches;
};

/**
 * Transforms a string array into another one with resolved scoped elements and caches it for future references
 *
 * @param {TemplateStringsArray} strings
 * @param {ScopedElementsMap} scopedElements
 * @param {Cache<TemplateStringsArray, TemplateStringsArray>} templateCache
 * @param {Cache<string, string>} tagsCache
 * @returns {TemplateStringsArray}
 */
var transformTemplate = function transformTemplate(strings, scopedElements, templateCache, tagsCache) {
  var transformedStrings = strings.map(function (str) {
    var acc = str;
    var matches = matchAll(str);
    for (var i = matches.length - 1; i >= 0; i -= 1) {
      var item = matches[i];
      var _item = _slicedToArray(item, 2),
        block = _item[0],
        tagName = _item[1];
      var tag = registerElement(tagName, scopedElements[tagName], tagsCache);
      var start = item.index + block.length - tagName.length;
      var end = start + tagName.length;
      var isClosingTag = block.indexOf('</') === 0;
      acc = acc.slice(0, start) + (isClosingTag ? tag : "".concat(tag, " data-tag-name=\"").concat(tagName, "\"")) + acc.slice(end);
    }
    return acc;
  });

  // @ts-ignore
  // noinspection JSCheckFunctionSignatures
  templateCache.set(strings, transformedStrings);

  // @ts-ignore
  // noinspection JSValidateTypes
  return transformedStrings;
};

/**
 * Obtains the cached strings array with resolved scoped elements or creates it
 *
 * @exports
 * @param {TemplateStringsArray} strings
 * @param {ScopedElementsMap} scopedElements
 * @param {import('./Cache.js').Cache<TemplateStringsArray, TemplateStringsArray>} templateCache
 * @param {import('./Cache.js').Cache<string, string>} tagsCache
 * @returns {TemplateStringsArray}
 */
function transform(strings, scopedElements) {
  var templateCache = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : globalCache;
  var tagsCache = arguments.length > 3 ? arguments[3] : undefined;
  return templateCache.get(strings) || transformTemplate(strings, scopedElements, templateCache, tagsCache);
}

export { transform };
